import type {Loan} from 'typings/portaro.be.types';
import type {RenewableLoan, RenewalRequest} from 'typings/portaro.fe.types';

export function createRenewableLoanFromLoan(loan: Loan, renewalRequest: RenewalRequest): RenewableLoan {
    const renewableLoan = loan as RenewableLoan;
    renewableLoan.renewalRequest = renewalRequest;
    return renewableLoan;
}
